import { Box, Button, Stack, Text, Title, useMantineTheme } from "@mantine/core"

import { Card } from "@tfg/ui"

import styles from "./BlurredOverlayWithModal.module.css"

export type BlurredOverlayWithModalProps = {
  title: string
  message: string
  buttonText: string
  showModal?: boolean
  onButtonClick: () => void
}
export const BlurredOverlayWithModal = ({
  title,
  message,
  buttonText,
  showModal = true,
  onButtonClick,
}: BlurredOverlayWithModalProps) => {
  const theme = useMantineTheme()
  return (
    <Box className={styles.root} h="100%" w="100%" pos="absolute">
      {showModal && (
        <Card
          bg="white"
          p="md"
          ta="center"
          miw={theme.other.widths.card.width.default}
          maw={theme.other.widths.card.width.lg}
          style={{
            "--mantine-scale": 1,
          }}
        >
          <Stack gap="md">
            <Title order={3}>{title}</Title>
            <Text>{message}</Text>
            <Button size="sm" onClick={onButtonClick}>
              {buttonText}
            </Button>
          </Stack>
        </Card>
      )}
    </Box>
  )
}
